import clsx from "clsx";

interface Props extends React.PropsWithChildren {
  collapsed?: boolean;
}
export const CardContent: React.FC<Props> = ({ collapsed, children }) => {
  return <div className={clsx("cpln-ant-card-content", { collapsed })}>{children}</div>;
};
